module.exports = __webpack_public_path__ + "img/service4.30bcbbe0.jpg";